import React from "react";

const BdOffice = () => {
  return (
    <div className="border p-8 bg-[#8884d8] w-full">
      <div className="flex justify-between items-center">
        <div>
          <h1>Street: 17/4 Dhanmondi.</h1>
          <h1>City: Dhaka</h1>
          <h1>Phone: +8801862450175</h1>
          <h1>Email: contact.bd@cc.com</h1>
        </div>
        <div>
          <h1 className="text-2xl">BANGLADESH OFFICE</h1>
        </div>
      </div>
    </div>
  );
};

export default BdOffice;
